"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var rql_1 = require("../../schemas/rql");
var bind_1 = require("../../bind");
var I18n = require("i18n-js");
var address_summary_1 = require("./address_summary");
var AddressRow = /** @class */ (function (_super) {
    tslib_1.__extends(AddressRow, _super);
    function AddressRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressRow.prototype.handleMakePrimary = function (e) {
        e.preventDefault();
        this.props.onMakePrimary(this.props.address);
    };
    AddressRow.prototype.handleEdit = function (e) {
        e.preventDefault();
        this.props.onEdit(this.props.address);
    };
    Object.defineProperty(AddressRow.prototype, "isEuOdrAddress", {
        get: function () {
            return this.props.addressType === rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM;
        },
        enumerable: true,
        configurable: true
    });
    AddressRow.prototype.renderPrimary = function () {
        if (this.isEuOdrAddress) {
            return null;
        }
        var address = this.props.address;
        if (address.primary) {
            return (React.createElement("div", { className: "label-tag" }, I18n.t('discovery.addressBook.row.defaultLabel')));
        }
        return (React.createElement("button", { "data-mark-primary": true, className: "button-as-link", type: "button", onClick: this.handleMakePrimary }, I18n.t('discovery.addressBook.row.actions.makeDefault')));
    };
    AddressRow.prototype.renderEuAddressDetails = function () {
        return (React.createElement("div", { className: "mt-1" },
            React.createElement("p", { className: "formatted-address" },
                this.props.address.phone,
                React.createElement("br", null),
                this.props.address.email)));
    };
    AddressRow.prototype.render = function () {
        var address = this.props.address;
        return (React.createElement("li", { className: "actionable-row" },
            React.createElement("div", { className: "actionable-row__content" },
                React.createElement(address_summary_1.AddressSummaryWithCountries, { address: address }),
                this.isEuOdrAddress && this.renderEuAddressDetails()),
            React.createElement("ul", { className: "actionable-row__actions" },
                React.createElement("li", { className: "actionable-row__action" }, this.renderPrimary()),
                React.createElement("li", { className: "actionable-row__action" },
                    React.createElement("button", { "data-edit-address": true, className: "button-as-link icon-l-pencil", onClick: this.handleEdit, type: "button" }, I18n.t('discovery.addressBook.row.actions.edit'))))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], AddressRow.prototype, "handleMakePrimary", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressRow.prototype, "handleEdit", null);
    return AddressRow;
}(React.Component));
exports.default = AddressRow;
//# sourceMappingURL=address_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/address_row.js
// module id = 8ntc
// module chunks = 20 21